import B_State from '../../../base/dev/model/B_State';

const init = () => {
    return class R_State extends B_State {
        get(point = 0) {
            return {
                play: this._play,
                clear: this._clear,
                reason: this._reason,
                meta: this._meta ? this._meta._id : undefined,
                point
            };
        }
    };
};

export default init();



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/runner/dev/model/R_State.js